import XHR from '../../utils/_xhr'

export default class PostService {
  static getPosts (options) {
    return XHR.post(window.main_theme_objects.ajax_url, {
      params: options
    })
      .then(res => {
        return JSON.parse(res.responseText)
      })
      .catch(err => {
        return err
      })
  }
}
